import type { PDFViewer } from "pdfjs-dist/web/pdf_viewer.mjs";
import { viewportToScaled } from "../lib/coordinates";
import type {
  IHighlight,
  LTWHP,
  Position,
  Scaled,
  ScaledPosition,
} from "../types";
import type { ViewportHighlight } from "./PdfHighlighter";

interface HighlightLayerProps<T> {
  highlightsByPage: { [pageNumber: string]: Array<T> };
  pageNumber: string;
  highlightTransform: (
    highlight: ViewportHighlight<T>,
    index: number,
    viewportToScaled: (rect: LTWHP) => Scaled
  ) => JSX.Element;
  scaledPositionToViewport: (scaledPosition: ScaledPosition) => Position | null;
  viewer: PDFViewer;
}

export function HighlightLayer<T extends IHighlight>({
  highlightsByPage,
  scaledPositionToViewport,
  pageNumber,
  highlightTransform,
  viewer,
}: HighlightLayerProps<T>) {
  const currentHighlights = highlightsByPage[String(pageNumber)] || [];
  return (
    <div>
      {currentHighlights.map((highlight, index) => {
        const position = scaledPositionToViewport(highlight.position);
        if (!position) {
          return null;
        }
        const viewportHighlight: ViewportHighlight<T> = {
          ...highlight,
          position,
        };

        return highlightTransform(viewportHighlight, index, (rect: LTWHP) => {
          const pageView = viewer.getPageView(
            (rect.pageNumber || Number.parseInt(pageNumber)) - 1
          );
          if (!pageView?.viewport) {
            return rect as unknown as Scaled;
          }

          return viewportToScaled(rect, pageView.viewport);
        });
      })}
    </div>
  );
}
